import React, { useEffect, useState } from 'react';
import { Badge, Menu, MenuItem, ListItemIcon, Checkbox, IconButton, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useLanguage } from 'Context/LanguageContext';
import DatesFilterUtil from 'OldComponents/Analitics/DatesFilterUtil';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Tooltip from '@mui/material/Tooltip';

const StyledBadge = styled(Badge)(() => ({
	'& .MuiBadge-badge': {
		backgroundColor: '#dc5c87',
		color: 'white',
	},
}));
const DropdownDatesFilter = (
	{
		isLoading,
		onChangeValues = () => {},
		executeFilters = () => {},
		showApplyButton,
		disabled,
		style,
		values: valuesProp
	}) => {
	const lan = useLanguage();
	const [values, setValues] = useState(valuesProp);
	const [anchorEl, setAnchorEl] = useState(null);
	const [filterTimeExecution, setFilterTimeExecution] = useState(valuesProp.includes(DatesFilterUtil.EXECUTION_PERIOD_TIME));
	const [filterExecutionDate, setFilterExecutionDate] = useState(valuesProp.includes(DatesFilterUtil.EXECUTION_DATE));
	const [filterCreationDate, setFilterCreationDate] = useState(valuesProp.includes(DatesFilterUtil.CREATION_DATE));
	const handleClose = () => setAnchorEl(null);
	const handleClick = (e) => setAnchorEl(e.currentTarget);
	const handleFilter = () => {
		executeFilters();
		handleClose();
	};
	const handleChangeTimeExecution = (e) => { e.stopPropagation(); setFilterTimeExecution(!filterTimeExecution); };
	const handleChangeExecutionDate = (e) => { e.stopPropagation(); setFilterExecutionDate(!filterExecutionDate); };
	const handleChangeCreationDate = (e) => { e.stopPropagation(); setFilterCreationDate(!filterCreationDate); };
	useEffect(() => onChangeValues(values), [values, onChangeValues]);
	useEffect(() => {
		setFilterTimeExecution(valuesProp.includes(DatesFilterUtil.EXECUTION_PERIOD_TIME));
		setFilterExecutionDate(valuesProp.includes(DatesFilterUtil.EXECUTION_DATE));
		setFilterCreationDate(valuesProp.includes(DatesFilterUtil.CREATION_DATE));
		setValues(valuesProp);
	}, [valuesProp]);
	useEffect(() => {
		const val = [];
		if (filterTimeExecution) val.push(DatesFilterUtil.EXECUTION_PERIOD_TIME);
		if (filterExecutionDate) val.push(DatesFilterUtil.EXECUTION_DATE);
		if (filterCreationDate) val.push(DatesFilterUtil.CREATION_DATE);
		setValues(val);
	}, [filterTimeExecution, filterExecutionDate, filterCreationDate]);

	return (
		<div style={style}>
			<StyledBadge badgeContent={isLoading ? 0 : values.length} invisible={disabled}>
				<Tooltip title={lan.filterBy || 'Filter by'}>
					<Box component="span" sx={{ display: 'inline-flex' }}>
						<IconButton
							id={"btn-dropdown-dates-filter"}
							onClick={handleClick}
							disabled={disabled || isLoading}
							size="small">
							<FilterAltOutlinedIcon />
						</IconButton>
					</Box>
				</Tooltip>
			</StyledBadge>
			<Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose} sx={{ p: 3 }}>
				<MenuItem onClick={handleChangeTimeExecution}>
					<ListItemIcon>
						<Checkbox checked={filterTimeExecution} sx={{ '&.Mui-checked': { color: '#ed1039 !important' } }} />
					</ListItemIcon>
					{lan.timeExecution}
				</MenuItem>
				<MenuItem onClick={handleChangeExecutionDate}>
					<ListItemIcon>
						<Checkbox checked={filterExecutionDate} sx={{ '&.Mui-checked': { color: '#ed1039 !important' } }} />
					</ListItemIcon>
					{lan.executionDate}
				</MenuItem>
				<MenuItem onClick={handleChangeCreationDate}>
					<ListItemIcon>
						<Checkbox checked={filterCreationDate} sx={{ '&.Mui-checked': { color: '#ed1039 !important' } }} />
					</ListItemIcon>
					{lan.creationDate}
				</MenuItem>
				{showApplyButton && (
					<div className="row d-flex justify-content-end mx-1">
						<button type="button" className="btn btn-outline-primary ml-auto mr-3" onClick={handleFilter}>
							{lan.apply}
						</button>
					</div>
				)}
			</Menu>
		</div>
	);
};

export default DropdownDatesFilter;
